import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    transition: all ", "s ease;\n\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["", "", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { transitionDurationInSec } from '../../constants';
import { getPropsBlocker } from '../../utils';

var labelStyle = function labelStyle(_ref) {
  var SelectorLabel = _ref.theme.componentOverrides.SelectorLabel,
      disabled = _ref.disabled,
      error = _ref.error;
  var enhancements = '';

  if (disabled && error) {
    enhancements = SelectorLabel.Label.disabled__error;
  } else if (disabled) {
    enhancements = SelectorLabel.Label.disabled;
  } else if (error) {
    enhancements = SelectorLabel.Label.error;
  }

  return css(_templateObject(), SelectorLabel.Label.base, enhancements);
};

export var SelectorLabelRoot = styled.div.withConfig(getPropsBlocker())(_templateObject2(), transitionDurationInSec, labelStyle);